export default "dist/images/block-container-image3.c734966.png";